import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Reservation } from "@/types/reservation";
import { FoldableContainer } from "@/components/pages/chats/component/booking-info-components/FoldableContainer";
import { Badge } from "@/components/ui/badge";
import { RequestBookingInfoDisplay } from "@/components/pages/chats/component/booking-info-components/RequestBookingInfoDisplay";

interface RequestsBookingInfoProps {
  booking: Reservation;
}

export const RequestsBookingInfo: FC<RequestsBookingInfoProps> = ({
  booking,
}) => {
  const { t } = useTranslation();
  const { serviceRequests } = booking;

  if (!serviceRequests || serviceRequests.length === 0) {
    return null;
  }

  const extraNode = (
    <Badge variant="outline" className="shrink-0">
      {serviceRequests.length}
    </Badge>
  );

  return (
    <FoldableContainer
      titleNode={t("chats.requests")}
      extraNode={extraNode}
      contentClassName="px-0 gap-2"
    >
      <div className="flex flex-col gap-2">
        {booking.serviceRequests.map((request) => (
          <RequestBookingInfoDisplay key={request.id} requestId={request.id} />
        ))}
      </div>
    </FoldableContainer>
  );
};
